// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__P9FMc","learnMore":"Disclaimer_learnMore__atMQd"};